export default __webpack_public_path__ + "static/media/clients.f75513fa.mp4";